<template>
  <div class="h-full flex flex-col bg-ld-background">
    <AppBar
      :title="_t('user.preference')"
      @back="onBack"
    />
    <div class="flex flex-col p-4">
      <ListCell
        :title="_t('user.setting_1')"
        :arrow="false"
      >
        <template #action>
          <InputSwitch
            :model-value="store.soundFeedbackOn"
            @update:modelValue="onSoundFeedbackChange"
          />
        </template>
      </ListCell>
      <ListCell
        v-if="_global.isInsideApp"
        :title="_t('user.setting_2')"
        :arrow="false"
      >
        <template #action>
          <InputSwitch
            :model-value="store.vibrateFeedbackOn"
            @update:modelValue="onHapticFeedbackChange"
          />
        </template>
      </ListCell>
    </div>
  </div>
</template>

<script setup lang="ts">
import ListCell from '@/components/ListCell/ListCell.vue'
import AppBar from '@/mobile/components/AppBar.vue'
import { useCommonStore } from '@/stores/common-store'

const store = useCommonStore()

const emit = defineEmits<{
  back: []
}>()

function onHapticFeedbackChange(value: boolean) {
  store.setVibrateFeedbackOn(value)
}
function onSoundFeedbackChange(value: boolean) {
  store.setSoundFeedbackOn(value)
}

function onBack() {
  emit('back')
}
</script>

<style scoped></style>
